export const PORTAL_VIEW_PATHS = Object.freeze({
    dashboard: '/dashboard',
    'ai-assistant': '/offers/ai-assistant',
    'send-offer': '/offers/send',
    'bundle-builder-beta': '/offers/bundle-builder-beta',
    'tv-packages': '/offers/tv-packages',
    'tv-packages-v2': '/offers/tv-packages-v2',
    'promo-combo-price': '/offers/promo-combo-price',
    'rogers-pricing': '/offers/rogers-pricing',
    templates: '/offers/templates',
    'tv-pricing': '/offers/tv-pricing',
    'tv-pricing-v2': '/offers/tv-pricing-v2',
    'theme-pack-editor': '/offers/theme-pack-editor',
    'email-settings': '/offers/email-settings',
    'all-history': '/offers/all-history',
    'my-history': '/offers/my-history',
    training: '/training/manual',
    'new-training': '/training/view',
    'training-test': '/training/test',
    'training-management': '/training/management',
    'new-training-management': '/training/new-management',
    'training-test-management': '/training/test-management',
    'system-reports': '/performance/reports',
    'calls-performance-webhook': '/performance/calls',
    'advanced-call-analytics': '/performance/advanced-calls',
    sds: '/performance/sds',
    users: '/users',
    'agent-dashboard-manager': '/users/agent-dashboard-manager',
    escalations: '/escalations',
    'bundle-builder': '/coming-soon/bundle-builder',
    'pricing-manager': '/coming-soon/pricing-manager'
});

export const PORTAL_PATH_VIEWS = Object.freeze({
    '/': 'dashboard',
    '/dashboard': 'dashboard',
    '/offers/send': 'send-offer',
    '/offers/send-offer': 'send-offer',
    '/offers/bundle-builder-beta': 'bundle-builder-beta',
    '/offers/tv-packages': 'tv-packages',
    '/offers/tv-packages-v2': 'tv-packages-v2',
    '/offers/tv-calculator': 'tv-packages-v2',
    '/offers/promo-combo-price': 'promo-combo-price',
    '/offers/rogers-pricing': 'rogers-pricing',
    '/offers/templates': 'templates',
    '/offers/tv-pricing': 'tv-pricing',
    '/offers/tv-pricing-v2': 'tv-pricing-v2',
    '/offers/theme-pack-editor': 'theme-pack-editor',
    '/offers/email-settings': 'email-settings',
    '/offers/all-history': 'all-history',
    '/offers/my-history': 'my-history',
    '/offers/ai-assistant': 'ai-assistant',
    '/training/manual': 'training',
    '/training/view': 'new-training',
    '/training/test': 'training-test',
    '/training/management': 'training-management',
    '/training/new-management': 'new-training-management',
    '/training/test-management': 'training-test-management',
    '/performance/reports': 'system-reports',
    '/performance/calls': 'calls-performance-webhook',
    '/performance/advanced-calls': 'advanced-call-analytics',
    '/performance/sds': 'sds',
    '/users': 'users',
    '/users/agent-dashboard-manager': 'agent-dashboard-manager',
    '/escalations': 'escalations',
    '/coming-soon/bundle-builder': 'bundle-builder',
    '/coming-soon/pricing-manager': 'pricing-manager'
});

const ROOT_FALLBACK_VIEWS = Object.freeze({
    offers: 'send-offer',
    training: 'training',
    performance: 'system-reports',
    users: 'users',
    escalations: 'escalations',
    'coming-soon': 'bundle-builder'
});

const SPECIAL_BREADCRUMBS = Object.freeze({
    '/coming-soon/bundle-builder': [
        { label: 'Home', path: '/dashboard' },
        { label: 'Offers & Email', path: '/dashboard' },
        { label: 'Bundle Builder Admin Tools', path: '/coming-soon/bundle-builder' }
    ],
    '/coming-soon/pricing-manager': [
        { label: 'Home', path: '/dashboard' },
        { label: 'Product & Pricing', path: '/dashboard' },
        { label: 'Product Pricing Manager', path: '/coming-soon/pricing-manager' }
    ]
});

const PAGE_LABELS = Object.freeze({
    'ai-assistant': 'AI Assistant',
    send: 'Send Offer Templates',
    'send-offer': 'Send Offer Templates',
    'bundle-builder-beta': 'Bundle Builder Beta',
    'tv-packages': 'TV Package Calculator V1',
    'tv-packages-v2': 'TV Package Calculator',
    'tv-calculator': 'TV Package Calculator',
    'promo-combo-price': 'TELUS Promo Combo',
    'rogers-pricing': 'Rogers Pricing',
    templates: 'Templates',
    'tv-pricing': 'TV Package Pricing V1',
    'tv-pricing-v2': 'TV Package Pricing & Channels',
    'theme-pack-editor': 'Theme Pack Editor',
    'email-settings': 'Email Settings',
    'all-history': 'All History',
    'my-history': 'My History',
    manual: 'TELUS Sales Manual',
    view: 'Training',
    management: 'Training Management',
    'new-management': 'New Training Management',
    'training-test': 'Training Test',
    'training-test-management': 'Training Test Management',
    reports: 'Performance Reports',
    calls: 'Calls Analytics',
    'advanced-calls': 'Advanced Call Analytics',
    'agent-dashboard-manager': 'Agent Dashboard Manager',
    escalations: 'Escalations',
    'bundle-builder': 'Bundle Builder Admin Tools',
    'pricing-manager': 'Product Pricing Manager'
});

export function getPortalViewFromPath(pathname, { isActualAdmin = false } = {}) {
    const path = String(pathname || '/');
    if (path.startsWith('/coming-soon') && !isActualAdmin) {
        return 'dashboard';
    }
    if (PORTAL_PATH_VIEWS[path]) {
        return PORTAL_PATH_VIEWS[path];
    }
    const parts = path.split('/').filter(Boolean);
    if (parts.length === 1) {
        return ROOT_FALLBACK_VIEWS[parts[0]] || 'dashboard';
    }
    return 'dashboard';
}

export function getPortalPathForView(viewId) {
    return PORTAL_VIEW_PATHS[viewId] || '/dashboard';
}

export function getPortalBreadcrumbs(pathname, { effectiveIsAdmin = false } = {}) {
    const path = String(pathname || '/');
    const home = [{ label: 'Home', path: '/dashboard' }];
    if (path === '/' || path === '/dashboard') {
        return home;
    }
    if (SPECIAL_BREADCRUMBS[path]) {
        return SPECIAL_BREADCRUMBS[path];
    }

    const parts = path.split('/').filter(Boolean);
    const groupLabels = {
        offers: effectiveIsAdmin ? 'Offers & Email' : 'Quote Tools',
        training: 'Training',
        performance: 'Performance',
        users: 'Users',
        'coming-soon': 'Coming Soon'
    };
    if (groupLabels[parts[0]]) {
        const breadcrumbs = [...home, { label: groupLabels[parts[0]], path: `/${parts[0]}` }];
        if (parts.length >= 2 && PAGE_LABELS[parts[1]]) {
            breadcrumbs.push({ label: PAGE_LABELS[parts[1]], path });
        }
        return breadcrumbs;
    }
    if (parts[0] === 'escalations') {
        return [...home, { label: 'Escalations', path: '/escalations' }];
    }
    return home;
}
